<template>
  <div class="bg-white h-100">
    <div class="d-flex justify-content-between align-items-center px-4 py-3 border-bottom">
      <i class="mdi" :class="icon" style="font-size: 1.5rem"></i>
      <h4 class="text-center m-0">{{ title }}</h4>
      <span class="clickable" @click="$emit('close')">
        <i class="mdi mdi-close" style="font-size: 1.5rem"></i>
      </span>
    </div>
    <LmTreeSelect
      class="p-4"
      v-model="status"
      :pathToGetOptions="`/processes/statusavailable/${$route.params.id}`"
      :label="$t('select_new_status')"
      :placeholder="$t('select_new_status')"
    />
    <LmButton
      type="button"
      class="col-auto px-4"
      buttonClass="btn-info"
      :value="$t('save')"
      @click="onChangeStatus"
      :disabled="!status || isLoading"
    />
  </div>
</template>

<script>
// Components
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmButton from '@/components/form/elements/LmButton'

// Utils
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts'

export default {
  mixins: [lmToasts],
  components: {
    LmTreeSelect,
    LmButton
  },
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      status: null,
      isLoading: false
    }
  },
  methods: {
    async onChangeStatus () {
      try {
        this.isLoading = true
        await commonsApi.axiosPostWrapper('/processes/newstatus', {
          id: this.$route.params.id,
          status: this.status
        })
        this.lmToastSuccessMessage(`Se actualizó el estado a ${this.status.name} correctamente.`, `Operación realizada con éxito.`)
        this.$emit('onProcessStatusChange', this.status)
        this.$emit('close')
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
